import {
  createClientModulesRegistrar,
  type ClientModules,
  type ClientModulesState
} from '@hendrx/app-modules-registry/client';
import { load as loadAuthentication } from '@hendrx/authentication/entrypoints/client';
import { load as loadAuthorization } from '@hendrx/authorization/entrypoints/client';
import { load as loadFileStorage } from '@hendrx/file-storage/entrypoints/client';
import { load as loadLms } from '@hendrx/lms/entrypoints/client';
import { load as loadXApiEvents } from '@hendrx/xapi-events/entrypoints/client';

import { getEnvVar } from 'shared/utils/getEnvVar';

const clientModulesRegistrar = createClientModulesRegistrar<ClientModules>();
const { modules: clientModules } = clientModulesRegistrar;

const implementations = {
  authentication: getEnvVar('VITE_MODULE_AUTHENTICATION') as 'cet' | 'mocked',
  authorization: getEnvVar('VITE_MODULE_AUTHORIZATION') as 'core',
  fileStorage: getEnvVar('VITE_MODULE_FILE_STORAGE') as 'cet' | 'cloudinary' | 'local',
  lms: getEnvVar('VITE_MODULE_LMS') as 'cet' | 'mocked',
  xAPIEvents: getEnvVar('VITE_MODULE_XAPI') as 'cet' | 'mocked'
};

let initPromise: Promise<void> | null = null;

export async function initializeClientModules() {
  if (initPromise) return initPromise;

  initPromise = (async () => {
    await clientModulesRegistrar.initialize(async modulesRegistry => {
      const authentication = await loadAuthentication(implementations.authentication, {
        clientModules: modulesRegistry
      });
      const authorization = await loadAuthorization(implementations.authorization, {
        clientModules: modulesRegistry
      });
      const fileStorage = await loadFileStorage(implementations.fileStorage, {
        clientModules: modulesRegistry
      });
      const lms = await loadLms(implementations.lms, {
        clientModules: modulesRegistry
      });
      const xAPIEvents = await loadXApiEvents(implementations.xAPIEvents, {
        clientModules: modulesRegistry
      });

      const modules: ClientModules = {
        authentication,
        authorization,
        fileStorage,
        lms,
        xAPIEvents
      };

      return modules;
    });
  })();

  return initPromise;
}

export function getClientModulesState(): ClientModulesState {
  return clientModulesRegistrar.getState();
}

export { clientModules };
